import {
  NOTIFICATIONS,
  NOTIFICATION_TYPE,
} from '../../auction_manager/notifications';
import { getBidIncrementValue } from '../../auction_manager/utils';
import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { formatAmount } from './auction_formatter';

const AMOUNT_DATA = 'data-amount';

$(() => {
  const entityId = $('#_entity-id').val();
  const BID_INCREMENT_VALUE = getBidIncrementValue();

  const SELECTORS = {
    CURRENT_BID: $('#current-bid-amount'),
    AUTO_BID: $('#auto-bid-amount'),
    AUTO_BID_INCREASE_BUTTON: $('#auto-bid-increase'),
    AUTO_BID_REDUCE_BUTTON: $('#auto-bid-reduce'),
    AUTO_BID_CONFIRM_BUTTON: $('#auto-bid-button'),
    AUTO_BID_CONFIRM_BUTTON_VALUE: $('#auto-bid-button-value'),
    AUTO_BID_SET_MESSAGE: $('#auto-bid-set-message'),
    AUTO_BID_SET_MESSAGE_VALUE: $('#auto-bid-set-message-value'),
    WHAT_IS_AUTO_BID_WRAPPER: $('.what-is-auto-bid__wrapper'),
    WHAT_IS_AUTO_BID_BUTTON: $('.what-is-auto-bid__button'),
    WHAT_IS_AUTO_BID_POPOVER: $('.what-is-auto-bid__popover'),
    WHAT_IS_AUTO_BID_POPOVER_CLOSE_BUTTON: $(
      '.what-is-auto-bid__popover button'
    ),
  };

  const getCurrentValues = () => {
    const currentValue = parseInt(
      SELECTORS.CURRENT_BID.get(0)?.getAttribute(AMOUNT_DATA)
    );
    const autoBidValue = parseInt(
      SELECTORS.AUTO_BID.get(0)?.getAttribute(AMOUNT_DATA)
    );
    return { currentValue, autoBidValue };
  };

  const setNewAutoBid = (newAutoBidValue) => {
    const newAutoBidValueFormatted = formatAmount(newAutoBidValue);
    SELECTORS.AUTO_BID.get(0)?.setAttribute(AMOUNT_DATA, newAutoBidValue);
    SELECTORS.AUTO_BID.text(newAutoBidValueFormatted);
    SELECTORS.AUTO_BID_CONFIRM_BUTTON_VALUE.text(newAutoBidValueFormatted);
  };

  const increaseBid = () => {
    const { autoBidValue } = getCurrentValues();
    const newAutoBidValue = autoBidValue + BID_INCREMENT_VALUE;
    setNewAutoBid(newAutoBidValue);
    updateReduceButtonDisabledState();
  };

  const reduceBid = () => {
    if (isMoreThanMinimalNextBid()) {
      const { autoBidValue } = getCurrentValues();
      const newAutoBidValue = autoBidValue - BID_INCREMENT_VALUE;
      setNewAutoBid(newAutoBidValue);
      updateReduceButtonDisabledState();
    }
  };

  const isMoreThanMinimalNextBid = () => {
    const { currentValue, autoBidValue } = getCurrentValues();
    return autoBidValue > currentValue + BID_INCREMENT_VALUE;
  };

  const updateReduceButtonDisabledState = () => {
    const disabled = !isMoreThanMinimalNextBid();
    SELECTORS.AUTO_BID_REDUCE_BUTTON.attr('disabled', disabled);
  };

  const initialize = () => {
    const { currentValue } = getCurrentValues();
    const newAutoBidValue = currentValue + BID_INCREMENT_VALUE;
    setNewAutoBid(newAutoBidValue);
    updateReduceButtonDisabledState();
  };

  const onCurrentBidChanged = ({ amount }) => {
    const { autoBidValue } = getCurrentValues();
    const newAutoBidValue = amount + BID_INCREMENT_VALUE;
    if (newAutoBidValue > autoBidValue) {
      setNewAutoBid(newAutoBidValue);
    }
    updateReduceButtonDisabledState();
  };

  const handleAutoBidStateNotifications = (
    { notification, message, maxBid },
    context
  ) => {
    if (
      notification === NOTIFICATIONS.AUTO_INCREMENT_PLACED_WHILE_HIGHEST_BIDDER
    ) {
      const { autoBidValue } = context;
      displayAutoBidSection(autoBidValue);
    }
    if (notification === NOTIFICATIONS.UNEXPIRED_AUTO_INCREMENT_ALREADY_EXIST) {
      const { CancelAtAmount } = message;
      displayAutoBidSection(CancelAtAmount);
    }
    if (notification === NOTIFICATIONS.AUTO_INCREMENT_PLACED) {
      displayAutoBidSection(maxBid);
    }
  };

  const onAutoBidExpired = () => {
    SELECTORS.AUTO_BID_SET_MESSAGE.hide();
  };

  const displayAutoBidSection = (autoBidValue) => {
    const formattedAutoBidValue = formatAmount(autoBidValue);
    SELECTORS.AUTO_BID_SET_MESSAGE_VALUE.attr('data-value', autoBidValue);
    SELECTORS.AUTO_BID_SET_MESSAGE_VALUE.html(formattedAutoBidValue);
    SELECTORS.AUTO_BID_SET_MESSAGE.show();
  };

  const updateAutoBidStateAfterAuctionStatusUpdate = ({ amount }) => {
    if (SELECTORS.AUTO_BID_SET_MESSAGE.is(':visible')) {
      const autoBidAmount = parseInt(
        SELECTORS.AUTO_BID_SET_MESSAGE_VALUE.attr('data-value')
      );
      if (amount >= autoBidAmount) {
        setTimeout(() => {
          EVENT_BUS.dispatch(AUCTION_EVENTS.AUTO_BID_EXPIRED);
          EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
            notification: NOTIFICATIONS.MAX_BID_MET_OR_EXCEEDED,
            type: NOTIFICATION_TYPE.WARNING,
            message: {
              cancelAtAmount: autoBidAmount,
              lotNumber: entityId,
            },
          });
        }, 500);
      }
    }
  };

  const onWhatIsAutoBidButtonClicked = ($event) => {
    SELECTORS.WHAT_IS_AUTO_BID_POPOVER.show();
    adjustPopoverPosition($event);
  };

  const adjustPopoverPosition = ($event) => {
    const windowHeight = window.innerHeight;
    const { top: distanceToTop } = $event.currentTarget.getBoundingClientRect();
    const {
      height: popoverElementHeight,
    } = SELECTORS.WHAT_IS_AUTO_BID_POPOVER.get(0).getBoundingClientRect();
    const difference = windowHeight - (distanceToTop + popoverElementHeight);
    const minimalBottomOffset = 20;
    const defaultTop = `130%`;
    const top =
      difference < minimalBottomOffset
        ? `${difference - minimalBottomOffset}px`
        : defaultTop;

    SELECTORS.WHAT_IS_AUTO_BID_POPOVER.css({ top });
  };

  const hideWhatIsAutoBidPopover = () => {
    SELECTORS.WHAT_IS_AUTO_BID_POPOVER.hide();
  };

  const onRandomDocumentClick = ($event) => {
    const $target = $event.target;
    const isPopoverVisible = SELECTORS.WHAT_IS_AUTO_BID_POPOVER.is(':visible');
    const isWhatIsAutoBidElement = !!SELECTORS.WHAT_IS_AUTO_BID_WRAPPER.find(
      $target
    ).length;

    if (isPopoverVisible && !isWhatIsAutoBidElement) {
      hideWhatIsAutoBidPopover();
    }
  };

  initialize();

  EVENT_BUS.on(
    AUCTION_EVENTS.AFTER_AUCTION_STATUS_UPDATED,
    onCurrentBidChanged
  );
  EVENT_BUS.on(
    AUCTION_EVENTS.AFTER_AUCTION_STATUS_UPDATED,
    updateAutoBidStateAfterAuctionStatusUpdate
  );
  EVENT_BUS.on(
    AUCTION_EVENTS.SHOW_NOTIFICATION,
    handleAutoBidStateNotifications
  );
  EVENT_BUS.on(AUCTION_EVENTS.AUTO_BID_EXPIRED, onAutoBidExpired);

  SELECTORS.AUTO_BID_INCREASE_BUTTON.on('click', increaseBid);
  SELECTORS.AUTO_BID_REDUCE_BUTTON.on('click', reduceBid);
  SELECTORS.WHAT_IS_AUTO_BID_BUTTON.on('click', onWhatIsAutoBidButtonClicked);
  SELECTORS.WHAT_IS_AUTO_BID_POPOVER_CLOSE_BUTTON.on(
    'click',
    hideWhatIsAutoBidPopover
  );
  document.addEventListener('click', onRandomDocumentClick, true);

  $(window).on('unload', () => {
    SELECTORS.AUTO_BID_INCREASE_BUTTON.off('click', increaseBid);
    SELECTORS.AUTO_BID_REDUCE_BUTTON.off('click', reduceBid);
    SELECTORS.WHAT_IS_AUTO_BID_BUTTON.off(
      'click',
      onWhatIsAutoBidButtonClicked
    );
    SELECTORS.WHAT_IS_AUTO_BID_POPOVER_CLOSE_BUTTON.off(
      'click',
      hideWhatIsAutoBidPopover
    );
    document.removeEventListener('click', onRandomDocumentClick);
  });
});
